import { createFileRoute } from "@tanstack/react-router";
import { H2, LegalLayout, ProviderAddress } from "../components/legal-layout";
import { provider } from "../legal/provider";

export const Route = createFileRoute("/impressum")({ component: Impressum });

function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <H2>Angaben gemäß § 5 DDG</H2>
      <ProviderAddress />

      <H2>Kontakt</H2>
      <p>
        E-Mail: {provider.email}
        {provider.phone && (
          <>
            <br />
            Telefon: {provider.phone}
          </>
        )}
      </p>

      {provider.vatId && (
        <>
          <H2>Umsatzsteuer-Identifikationsnummer</H2>
          <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: {provider.vatId}</p>
        </>
      )}

      <H2>Verbraucherstreitbeilegung</H2>
      <p>
        archinventory richtet sich ausschließlich an Unternehmer. Wir sind nicht bereit und nicht
        verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>
    </LegalLayout>
  );
}
